import { Component, ElementRef, Inject, Injectable, ViewChild, ViewChildren, QueryList, Renderer2 } from '@angular/core';
import { faTimes, faExpandAlt, faCompressAlt, faPrint, faQuestionCircle, faArrowCircleUp, faArrowCircleDown, faFilter } from '@fortawesome/free-solid-svg-icons';
import { HttpClient } from '@angular/common/http';
import { InputText } from 'primeng/inputtext';
import { Message, MessageService } from 'primeng/api';
// import { UIChart } from 'primeng/chart';
// import { Chart } from 'chart.js';
import { ActivatedRoute } from '@angular/router';

@Injectable()
@Component({
  selector: 'app-history',
  styles: [`
    :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
      position: -webkit-sticky;
      position: sticky;
      top: 0;
      z-index: 999;
    }
  `],
  templateUrl: './history.component.html',
  providers: [MessageService]
})


export class HistoryComponent {
  
  @ViewChild('searchInput') searchInput: InputText;
  @ViewChildren('sourceTh') sourceTh: QueryList<ElementRef>;
  @ViewChildren('targetTh') targetTh: QueryList<ElementRef>;
  @ViewChildren('attendanceChart') attendanceChart: QueryList<ElementRef>;

  //public isCollapsed = false;

  faTimes = faTimes;
  faExpandAlt = faExpandAlt;
  faCompressAlt = faCompressAlt;
  faPrint = faPrint;
  faQuestionCircle = faQuestionCircle;
  faArrowCircleUp = faArrowCircleUp;
  faArrowCircleDown = faArrowCircleDown;
  faFilter = faFilter;

  public studentsdata: ResponseStudentProgram[];
  public studentsprogram: StudentProgram[];
  public sectionname: string;
  public gradingperiodobj: SectionGradingPeriodResponse[];
  public idx: number;
  public baseUri: string;
  public errorMessage: string;
  public httpClient: HttpClient;

  selectedStudents: StudentProgram[];

  loading: boolean = true;

  public expandedRowsHistory = {};
  public rows: number = 10;
  public isExpanded: boolean = false;
  public temDataLength: number = 0;

  public statusLogdata: ResponseStatusLogDetail[];
  public parent_StatusLogdata: ResponseStatusLogDetail[];

  // charts: Chart[] = [];
  attendanceChartData: any;
  attendanceChartOptions: any;
  allGrades: string[] = [];
  gradeCounts: {}
  gradeCountChart: any;
  gradeCountOptions: any;

  sectionid: string;
  realm: string;
  realm_id: string;
  app_id: string;
  is_ssl: string;

  msgs1: Message[];
  legacy = false; // set to true, if you want to render the original angular bindings UI

  public isReadOnlyMode = false;
  public selectedGP = "";

  constructor(
    public http: HttpClient,
    @Inject('BASE_URL') baseUrl: string,
    private renderer: Renderer2,
    private messageService: MessageService,
    private route: ActivatedRoute
  ) {

    this.route.queryParams.subscribe(params => {
     
      this.sectionid = params['realm_id'];
      this.realm = params['realm'];
      this.realm_id = params['realm_id'];
      this.app_id = params['app_id'];
      this.is_ssl = params['is_ssl'];

    });

    this.baseUri = baseUrl;
    this.httpClient = http;
    this.getstudentprogam(http, baseUrl);    
  }


  redirectHome() {
    location.href = '/?realm=' + this.realm + '&realm_id=' + this.realm_id + '&app_id=' + this.app_id + '&is_ssl=' + this.is_ssl;
  }
  getstudentprogam(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    http.get<ResponseStudentProgram[]>(baseUrl + 'studentgrade/get?SectionId=' + this.sectionid).subscribe(result => {
      this.studentsdata = result;
      this.gradingperiodobj = result[0].objGradingPeriods.grading_period;

      // For All Grading Periods selection -- dummy value 0000
      let allGP = {
        sectionId: 0, schoolTermGradingPeriodId: '0000', stGradingPeriodName: 'All Grading Periods', displayName: 'All Grading Periods',
        gradingPeriod: 'All Grading Periods', gradingPeriodState: 'Active', GradingPeriodMode: 'Active'
      }

      this.gradingperiodobj.push(allGP);

      this.selectedGP = this.gradingperiodobj.filter(gp => gp.gradingPeriod == 'All Grading Periods')[0].schoolTermGradingPeriodId;    

      this.getstatusLog(this.httpClient, this.baseUri);

    }, error => this.errorService(error));

  }

  getstatusLog(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    http.get<ResponseStatusLogDetail[]>(baseUrl + 'studentgrade/getstatuslog?SectionId=' + this.sectionid).subscribe(result => {
      this.statusLogdata = result;
      this.parent_StatusLogdata = result;

      this.loading = false;

    }, error => this.errorService(error));

  }

  getstatusLogInfoDetails(http: HttpClient, @Inject('BASE_URL') baseUrl: string, processId) {
    
    http.get<ResponseStatusLogInfoDetail[]>(baseUrl + 'studentgrade/getstatuslogdetails?ProcessId=' + processId).subscribe(result => {

      this.statusLogdata.forEach(data => {
        if (data.processId == processId) {
          data.lstLogStudentDetails = result;

          data.lstLogStudentDetails.forEach(detail => {
            let studentInfo = this.studentsdata.filter(c => c.school_uid == detail.studentId)[0];

            if (studentInfo.studentFirstName != null && studentInfo.studentFirstName != "") {
              studentInfo.studentFirstName = studentInfo.studentFirstName.toUpperCase();
            }
            if (studentInfo.studentLastName != null && studentInfo.studentLastName != "") {
              studentInfo.studentLastName = studentInfo.studentLastName.toUpperCase();
            }
            if (studentInfo.studentMiddleName != null && studentInfo.studentMiddleName != "") {
              studentInfo.studentMiddleName = studentInfo.studentMiddleName.toUpperCase();
            }

            detail.studentName = studentInfo.studentFirstName + " " + studentInfo.studentLastName + " " + studentInfo.studentMiddleName + "(" + studentInfo.school_uid + ")";
          })
        }
      })
    }, error => this.errorService(error));

  }

  OnChangeGradingPeriod() {
    // For All Grading Periods selection -- dummy value 0000
    if (this.selectedGP == '0000') {
      this.statusLogdata = this.parent_StatusLogdata;
    }
    else {
      this.statusLogdata = this.parent_StatusLogdata.filter(c => c.schoolTermGradingPeriodId == this.selectedGP);
    }

  }

  onRowExpand(data) {
    
    //console.log(data) // All data for this specific student
   // console.log("row expanded", Object.keys(this.expandedRowsHistory).length)    
   // console.log(this.expandedRowsHistory) // Student UID of expanded row

    let processId = data.data.processId;
    this.getstatusLogInfoDetails(this.httpClient, this.baseUri, processId);

    if (Object.keys(this.expandedRowsHistory).length === this.temDataLength) {
      this.isExpanded = true;
    }
  }

  errorService(error) {
    var timestamp = ''; // to do - make unique tracker
    //console.error(error)
    //this.messageService.add({ sticky: true, severity: 'error', summary: 'Error ' + error.status, detail: error.message })
  }  
}

interface ResponseStudentProgram {
  school_uid: string;
  studentFirstName: string;
  studentLastName: string;
  studentMiddleName: string;  
  //StudentName: string;
  enrollment_id: string;
  missing_assignments: string;
  letter_grade: string;
  grade: number;
  objStudentProgram: StudentProgram[];
  objGradingPeriods: SectionGradingPeriodsResponse;
  index: number;
  isCollapsed: boolean;
  isChecked: boolean;
}

interface SectionGradingPeriodsResponse {
  grading_period: SectionGradingPeriodResponse[];
}

interface SectionGradingPeriodResponse {
  sectionId: number;
  schoolTermGradingPeriodId: string;
  stGradingPeriodName: string;
  displayName: string;
  gradingPeriod: string;
  gradingPeriodState: string;
  GradingPeriodMode: string;
}


interface StudentProgram {
  studentCourseGradeID : string;
  schoolTermGradingPeriodID: string;
  studentID : string;
  gradingMilestoneID: string;
  gradingScaleID: string;
  citizenshipCode: string;
  workHabitCode: string;
  sectionID: string;
  letterGrade: string;
  comment1: string;
  comment2: string;
  comment3: string;
  studentCode: string;
  firstName: string;
  lastName: string;
  middleName: string;
  name: string;
  staffID: string;
  employeeID: string;
  givenBy: string;
  givenByStaffID: string;
  schoolID: number;
  schoolYearID: number;
  gradeLevelID: string;
  schoolTermID: number;
  schoolTermEndDate: number;
  courseID: number;
  attemptedCredit: number;
  earnedCredit: number;

  modifiedDate: Date;
  createdDate: Date;

  createdBy: string;
  modifiedBy: string;
  postGradingScaleID: string;
  postCitizenshipCode: string;
  postWorkHabitCode: string;
  postSectionID: string;
  postLetterGrade: string;
  postComment1: string;
  postComment2: string;
  postComment3: string;

  gradingPeriodFullName: string;
  selectedWorkHabitID: number;
  selectedGradingScaleID: number;
  selectedCitizenshipCode: string;

  present: number;
  absent: number;
  tardy: number;
}

interface ResponseStatusLogDetail {
  processId: string;
  sectionId: string;
  schoolTermGradingPeriodId: string;
  syncStatus: string;
  totalStudentCount: number;
  successStudentCount: number;
  failedStudentCount: number;
  publishedTime: string;
  submissionStatus: string;
  failurePercent: string;
  isCollapsed: boolean;
  lstLogStudentDetails: ResponseStatusLogInfoDetail[];
}

interface ResponseStatusLogInfoDetail {
  studentCourseGradeId: string;
  studentId: string;
  responseCode: string;
  message: string;
  employeeId: string;
  sectionId: string;
  studentName: string;
}


